<script lang="ts">
    import Step from "../components/wizard/Step.svelte";
    import NextButton from "../components/NextButton.svelte";
    import TwoCols from "../components/TwoCols.svelte";
    import type {FileWithPath} from 'file-selector';
    import MultiInput from "../components/MultiInput.svelte";
    import FileUpload from "../components/FileUpload.svelte";
    import ErrorBox from "../components/ErrorBox.svelte";
    import {_} from '../services/i18n.js';

    export let files: FileWithPath[] = [];
    export let description: string | null = null;
    export let links: string[] = [];
    declare var lang: string;

    export let typeID = null

    export let currentStep: number;
    $:{
        if(currentStep == 3){

            //console.log("set focus for 3")
        }
    }

    // validate URLs
    $: urlsOk = links.map(link => {
        try {
            new URL(link);
            return true;
        } catch { // invalid url
            return false;
        }
    }).every(isOK => isOK) && links.length > 0;

    export function validate() {
        showErrors = true;
        return urlsOk;
    }

    let showErrors = false;
</script>
<Step let:nextStep num={3} {validate}>
    {#if typeID != 3}
        <TwoCols rightStyle="display: flex; flex-direction: column" ratio={0.6}>
            <svelte:fragment slot="left">
                <h1 class="main-heading">{$_('stepContent.title')}
                    <span class="heading-subtitle">(.jpg, .png, webp, .gif)</span>
                </h1>
                <div class="file-upload-container">
                    <!-- 10MB, maximum 3 files .heic,.heif, -->
                    <FileUpload bind:files max={3} maxSize={10000000} accept=".jpeg,.jpg,.png,.webp,.gif"/>
                </div>
            </svelte:fragment>
            <svelte:fragment slot="right">
            </svelte:fragment>
        </TwoCols>
    {/if}

    <TwoCols rightStyle="display: flex; flex-direction: column" ratio={0.6}>
        <svelte:fragment slot="left">
            <h1 class="main-heading">{$_('stepContent.addText')}</h1>
            <textarea title="{ $_('stepContent.addTextPlaceholder') }..." placeholder="{ $_('stepContent.addTextPlaceholder') }..."
                      bind:value={description}
                      on:keypress|stopPropagation></textarea>
        </svelte:fragment>
        <svelte:fragment slot="right">
            {#if lang == 'en'}
                <h2 class="red-title aligned-title">Text</h2>

                <p class="info-text">Here you can provide any other additional information that you believe would be
                    useful to the
                    BEE SECURE Stopline to deal with the report.</p>
            {/if}
            {#if lang == 'de'}
                <h2 class="red-title aligned-title">Text</h2>

                <p class="info-text">Hier können Sie zusätzliche Informationen eingeben,
                    die Sie als nützlich für die Bearbeitung der Meldung durch die BEE SECURE Stopline erachten.</p>
            {/if}
            {#if lang == 'fr'}
                <h2 class="red-title aligned-title">Texte</h2>

                <p class="info-text">Veuillez donner toutes autres informations supplémentaires que vous jugez utile de
                    communiquer à la
                    BEE SECURE Stopline afin de traiter le signalement.</p>
            {/if}
        </svelte:fragment>
    </TwoCols>

    <TwoCols rightStyle="display: flex; flex-direction: column; margin-bottom: 1em;" ratio={0.6}>
        <svelte:fragment slot="left">
            <h1 class="main-heading third-heading">{$_('stepContent.addUrl')} </h1>

            <MultiInput bind:values={links}></MultiInput>

            <ErrorBox show={showErrors && !urlsOk} msg="{$_('stepContent.errorUrls')}"></ErrorBox>
        </svelte:fragment>
        <svelte:fragment slot="right">
            {#if lang == 'en'}
                <h2 class="red-title aligned-title third-heading">URLs</h2>

                <p class="info-text">Please copy here the entire content of the address bar of your browser when you are
                    on the page containing the illegal content.</p>
                <p class="info-text">Example : https://stopline.bee-secure.lu</p>
                <p class="info-text">The analysts need a direct link for their work and, if available, the login
                    credentials, e.g. a password.</p>
            {/if}
            {#if lang == 'de'}
                <h2 class="red-title aligned-title third-heading">URLs</h2>

                <p class="info-text">Bitte kopieren Sie die vollständige Adressleiste Ihres Browsers, wenn Sie sich auf
                    der Seite mit dem illegalen Inhalt befinden.</p>
                <p class="info-text">Beispiel : https://stopline.bee-secure.lu</p>
                <p class="info-text">Die Analysten benötigen für ihre Arbeit einen direkten Link und, falls vorhanden,
                    die Zugangsdaten, z.B ein Passwort.</p>
            {/if}
            {#if lang == 'fr'}
                <h2 class="red-title aligned-title third-heading">URLs</h2>

                <p class="info-text">Veuillez copier ci-dessous le contenu de la barre d'adresse de navigateur dans son
                    intégralité, lorsque vous êtes sur la page contenant le contenu illégal.</p>
                <p class="info-text">Exemple : https://stopline.bee-secure.lu</p>
                <p class="info-text">Les analystes ont besoin d'un lien direct pour leur travail et, le cas échéant, des
                    identifiants de connexion, comme par exemple un mot de passe.</p>
            {/if}
        </svelte:fragment>
    </TwoCols>

    <NextButton {nextStep}></NextButton>
</Step>

<style lang="scss">
  .main-heading {
    margin-bottom: 25px;
  }

  .aligned-title {
    line-height: 33px; // same as .main-heading
  }

  .heading-subtitle {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0;
    text-align: left;
  }

  .file-upload-container {
    margin-bottom: 55px;
  }

  .third-heading {
    margin-top: 30px;
  }

  textarea {
    background: white;
    border: 2px dashed black;
    border-radius: 12px;
    height: 10em;
    padding:5px;

    &::placeholder {
      color: #C8C8C8;
      //font-family: 'Poppins', sans-serif;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0;
      text-align: left;
    }
  }

</style>
